import { GridColDef } from "@mui/x-data-grid";

const auditColumnDef: GridColDef[] = [
    { field: 'audit_id', headerName: 'ID', width: 90 },
    { field: 'field_name', headerName: 'Field Name', width: 150, sortable: true, filterable: true },
    { field: 'old_field_value', headerName: 'Old Value', width: 150, sortable: true, filterable: true },
    { field: 'new_field_value', headerName: 'New Value', width: 150, sortable: true, filterable: true },
    { field: 'created_date', headerName: 'Created Date', width: 150, sortable: true, filterable: true },
    { field: 'created_by', headerName: 'Created By', width: 150, sortable: true, filterable: true },
]

export default auditColumnDef;